import { VisAuthService, AuthServiceConfig } from '@vis-auth/vis-auth';
import { isSSALogin, isLoginDotGovLogin, onSSALoginPage } from './config/auth-config-helpers';
import { getSaveAuthConfiguration } from './config/save-auth-config';
import { getSsaAuthConfiguration } from './config/ssa-auth-config';
import { getLoginDotGovAuthConfiguration } from './config/login-dot-gov-auth-config';

export const getAuthConfig = (): AuthServiceConfig => {
  const isSSAUser = isSSALogin();
  const isLoginDotGovUser = isLoginDotGovLogin();
  if (onSSALoginPage()) {
    // if user is on SSALoginPage we want to clean up any token information
    // this step is only needed for SSA users.
    // If the mechanism in AuthServiceConfig for Stoage type ever changes, this code will need to get updated.
    localStorage.removeItem('_auth_token');
    localStorage.removeItem('_auth_user');
  }

  if (isSSAUser) {
    return getSsaAuthConfiguration();
  }

  return isLoginDotGovUser ? getLoginDotGovAuthConfiguration() : getSaveAuthConfiguration();
};

let authService: VisAuthService = undefined;

const replaceState = {
  replace(url: string) {
    window.history.replaceState({}, '', url);
  },
};

export const initiateAuthService = (authConfig: AuthServiceConfig) =>
  (authService = new VisAuthService(authConfig, replaceState));

export const getAuthService = (): VisAuthService => {
  if (authService) {
    return authService;
  }
  throw Error('Auth Service not instantiated');
};
